import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🦋", key: "transformed" },
  { emoji: "💎", key: "polished" },
  { emoji: "🔥", key: "bold" },
  { emoji: "🌟", key: "authentic" },
  { emoji: "🎭", key: "versatile" },
]

export default function LooksmaxxingFutureLookPage() {
  return (
    <RadioCardListPage
      translationKey="futureLookLooksmaxxing"
      options={OPTIONS}
    />
  )
}
